import { render, staticRenderFns } from "./PromptCancelStatusAutomations.vue?vue&type=template&id=52fbc826&scoped=true&"
import script from "./PromptCancelStatusAutomations.vue?vue&type=script&lang=js&"
export * from "./PromptCancelStatusAutomations.vue?vue&type=script&lang=js&"
import style0 from "./PromptCancelStatusAutomations.vue?vue&type=style&index=0&id=52fbc826&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbc826",
  null
  
)

export default component.exports